import type * as Y from "yjs";

/** Optional host-owned mutation boundary. Omission preserves the direct write. */
export interface CanvasMutation {
  readonly target: "note" | "widget";
  readonly action: "edit" | "move" | "delete" | "materialize" | "finish";
  readonly id: string;
  readonly entry: Y.Map<unknown>;
  readonly field?: string | undefined;
  /** Stable across all mutations in one gesture; use a new value for each gesture. */
  readonly gestureId?: string | undefined;
}

/** Return false to reject a stale or unavailable mutation without executing it. */
export type CanvasMutationHandler = (
  mutation: CanvasMutation,
  write: () => void,
) => boolean;

export function applyCanvasMutation(
  handler: CanvasMutationHandler | undefined,
  mutation: CanvasMutation,
  write: () => void,
): boolean {
  if (handler) return handler(mutation, write);
  write();
  return true;
}
